import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  LOGIN,
  FIND_SUBPASS,
  CREATE_SUBPASS,
  VER_SUBPASS,
  REFRESH,
  M_POST,
  PUBLIC_PG_KEY,
  PG_SECRET,
} from '@/utils/api';

import serviceUtils from '@/services/utils';

import Vue from 'vue';
import NodeRSA from 'node-rsa';
import jwt_decode from 'jwt-decode';

const RSA = new NodeRSA(PUBLIC_PG_KEY);

@Module({ name: 'auth' })
export default class Auth extends VuexModule {
  token: string = serviceUtils.getUserPersistent().token || '';

  refreshToken: string = serviceUtils.getUserPersistent().refreshToken || '';

  balance: number = serviceUtils.getUserBalance() || 0;

  user = serviceUtils.getUserPersistent().user || {};

  @Mutation
  mutateLogin(data: any) {
    const {
      token, balance, user, refreshToken,
    } = data;
    this.token = token;
    this.balance = balance;
    this.user = user;
    this.refreshToken = refreshToken;
  }

  @Action
  RefreshToken() {
    return Vue.axios({
      url: BASE_URL + REFRESH,
      method: M_POST,
    })
      .then(({ data: { data } }) => {
        const {
          token, refreshToken, user: { wallet: { balance } }, user,
        } = data;
        Vue.prototype.$session.start();
        Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(data));
        Vue.prototype.$session.set('ambgames-user-balance', balance);
        Vue.prototype.$session.set('ambgames-user-refresh-token', refreshToken);
        Vue.prototype.$session.set('ambgames-user-access-token', token);
        Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        this.context.commit('mutateLogin', {
          refreshToken, token, balance, user,
        });
        return data;
      })
      .catch((err) => err);
  }

  @Action
  Login(userdata: object) {
    return Vue.axios({
      url: BASE_URL + LOGIN,
      data: userdata,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        const decodeToken: any = data.data ? jwt_decode(data.data.token) : {};
        if (code === 0) {
          const encryptAuthorize = RSA.encrypt(PG_SECRET, 'base64');
          localStorage.setItem('x-authorize', encryptAuthorize);
          if (['SUPERADMIN', 'COMPANY'].includes(decodeToken.role) || data.data.user.username === 'aaa') {
            const {
              token, refreshToken,
            } = data.data;
            const totalData = {
              ...data.data,
              user: {
                ...data.data.user,
                ...decodeToken,
              },
            };
            const { user, user: { wallet: { balance } } } = totalData;
            Vue.prototype.$session.start();
            Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(totalData));
            Vue.prototype.$session.set('ambgames-user-balance', balance);
            Vue.prototype.$session.set('ambgames-user-refresh-token', refreshToken);
            Vue.prototype.$session.set('ambgames-user-access-token', token);
            Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            const model = {
              token,
              balance,
              user,
              refreshToken,
            };
            this.context.commit('mutateLogin', model);
            return data;
          } else {
            return code;
          }
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  check2Pass(username) {
    return Vue.axios({
      url: BASE_URL + FIND_SUBPASS,
      data: username,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  create2Pass(subPassFirst) {
    return Vue.axios({
      url: BASE_URL + CREATE_SUBPASS,
      data: subPassFirst,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  async verify2Pass(param) {
    return Vue.axios({
      url: BASE_URL + VER_SUBPASS,
      data: param,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const decodeToken: any = data.data ? jwt_decode(data.data.token) : {};
          const {
            token, refreshToken,
          } = data.data;
          const totalData = {
            ...data.data,
            user: {
              ...data.data.user,
              ...decodeToken,
            },
          };
          const { user, user: { wallet: { balance } } } = totalData;
          Vue.prototype.$session.start();
          Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(totalData));
          Vue.prototype.$session.set('ambgames-user-balance', balance);
          Vue.prototype.$session.set('ambgames-user-refresh-token', refreshToken);
          Vue.prototype.$session.set('ambgames-user-access-token', token);
          Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
          // serviceUtils.socketConnect();
          const model = {
            token,
            balance,
            user,
            refreshToken,
          };
          this.context.commit('mutateLogin', model);
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @MutationAction({ mutate: ['token', 'refreshToken'] })
  async Logout() {
    localStorage.removeItem('x-secure-code');
    localStorage.removeItem('x-authorize');
    serviceUtils.clearUserPersistent();
    return {
      token: '',
      refreshToken: '',
    };
  }

  @Mutation
  setProfile(data) {
    this.user = data;
    this.balance = this.user.wallet.balance;
  }

  get isAuthenticated() {
    return this.token;
  }

  get userPermission() {
    return this.user && this.user.userPermission;
  }

  get role() {
    return this.user && this.user.role;
  }

  get userBalance() {
    return serviceUtils.currencyFormatter(this.user.wallet.balance) || 0;
  }
}
